import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Stack } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import { useSites } from "@shared/hooks/SiteHook";
import useGlobalStore from "@shared/store/GlobalStore";
import LinkEditor from "@administration/components/editor/LinkEditor";
import { useHomePageLocation } from "@administration/hooks/PageHook";
import Navigation from "./Navigation/Navigation";
const Header = ({ children }) => {
    const { currentSite: site } = useSites();
    const { settings: siteSettings } = site || {};
    const { logoHeader = null } = siteSettings || {};
    const { isBo } = useGlobalStore((state) => ({ isBo: state.isBo }));
    const { homePage } = useHomePageLocation();
    return (_jsxs(Box, { component: "header", sx: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: "background.header",
            height: { xs: "72px", md: "88px" },
            zIndex: 10,
        }, children: [_jsx(Box, { component: "a", href: "#main-content", sx: {
                    position: "absolute",
                    top: 8,
                    left: 16,
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                    textDecoration: "none",
                    transform: "translateY(-200%)",
                    transition: "transform 0.2s ease",
                    zIndex: 20,
                    "&:focus, &:focus-visible": {
                        transform: "translateY(0)",
                        outline: "2px solid",
                        outlineColor: "primary.contrastText",
                        outlineOffset: 2,
                    },
                }, children: "Aller au contenu principal" }), _jsx(Container, { children: _jsxs(Stack, { component: "nav", direction: "row", sx: { alignItems: "center", justifyContent: "space-between", py: 1 }, children: [_jsx(Box, { sx: {
                                height: { xs: "56px", md: "72px" },
                                "& img": { height: "100%", width: { xs: "200px", md: "250px" } },
                            }, children: isBo ? (_jsx(LinkEditor, { page: homePage, "aria-label": "Lien vers la page d'accueil", children: logoHeader || (_jsx("img", { alt: "", src: "/logo-docaposte-agility-white.svg", width: 250 })) })) : (_jsx(Link, { url: "/", "aria-label": "Lien vers la page d'accueil", children: logoHeader || (_jsx("img", { alt: "", src: "/logo-docaposte-agility-white.svg", width: 250 })) })) }), _jsx(Navigation, {})] }) }), children] }));
};
export default Header;
